import * as React from 'react';
import {Alert, CircularProgress, Grid} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useFetchUserConfigQuery} from "../../store";
import {LoadingItem} from "../../components/loading-item/LoadingItem";
import ChatRoom from "../../components/chat-room/ChatRoom";


function Home() {
    const {t, i18n} = useTranslation();
    const {
        data: userConfig,
        error: userConfigError,
        isLoading: isUserConfigLoading,
    } = useFetchUserConfigQuery();

    if (isUserConfigLoading) {
        return <LoadingItem><CircularProgress/></LoadingItem>;
    }

    if (userConfigError) {
        return <Alert severity="error">{t("Cannot load user config!")}</Alert>;
    }

    if (!userConfig) {
        return <Alert severity="warning">{t("No user config found!")} ass</Alert>;
    }

    return (
        <div>
            <Grid container spacing={1}>
                <Grid item xs={12} lg={12}>
                    {/*<Chat chatId={userConfig.providerId}/>*/}
                    <ChatRoom roomId={userConfig.providerId}/>
                </Grid>
                <Grid item xs={12} lg={12}>
                    .
                </Grid>
            </Grid>
        </div>
    );
}

export default Home;